import { Button, Modal, Radio, Space } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./SortModal.module.css";
import { useEffect, useState } from "react";
import { sort_list } from "../../pages/Appointments/AppointmentTab/AppointmentTab";
import { ReactComponent as SortIcon } from "../../../assets/svg/sort.svg";

export default function SortModal({ onSubmit, value, shouldClear }) {
  const [open, setOpen] = useState(false);
  const [sort, setSort] = useState(value);
  const { t } = useTranslation();

  useEffect(() => {
    if (shouldClear) {
      setSort("");
    }
  }, [shouldClear]);

  return (
    <>
      <Modal
        open={open}
        footer={() => {
          return (
            <Button
              type="primary"
              style={{
                width: "100%",
              }}
              onClick={() => {
                onSubmit(sort);
                setOpen(false);
              }}
            >
              {t("common.sort")}
            </Button>
          );
        }}
        styles={{
          body: {
            paddingTop: "30px",
          },
        }}
        onCancel={() => {
          setOpen(false);
        }}
      >
        <Radio.Group
          onChange={(e) => {
            setSort(e.target.value);
          }}
          value={sort}
          className="w-full"
        >
          <Space direction="vertical" className="w-full">
            {sort_list.map((sortItem) => {
              return (
                <Radio value={sortItem.value} className={styles.radioButton}>
                  {t(`common.${sortItem.label}`)}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </Modal>
      <Button
        type="text"
        className={styles.sort_button}
        onClick={() => {
          setOpen(true);
        }}
      >
        <SortIcon width={16} height={16} />
      </Button>
    </>
  );
}
